"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = exports.uiKitTheme = exports.colors = exports.blackColors = exports.componoColors = exports.primaryColors = exports.criticalColors = exports.warningColors = exports.successColors = exports.statusColors = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _defaultProps = require("grommet/default-props");

var _TextInput = require("grommet/components/TextInput");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusColors = {
  ok: '#14B8A6',
  warning: '#F97316',
  critical: '#EF4444',
  disabled: '#EAEAEA',
  unknown: '#D5D5D5',
  invalid: '#FFF5F5',
  info: '#66A3E5'
};
exports.statusColors = statusColors;
var successColors = {
  success: '#14B8A6',
  success100: '#134E4A',
  success60: '#14B8A6',
  success10: '#CCFBF1',
  success5: '#EEFEFA'
};
exports.successColors = successColors;
var warningColors = {
  warning: '#F97316',
  warning100: '#C2410C',
  warning60: '#F97316',
  warning10: '#FFEDD5',
  warning5: '#FFF9F1'
};
exports.warningColors = warningColors;
var criticalColors = {
  critical: '#EF4444',
  critical100: '#B91C1C',
  critical60: '#EF4444',
  critical10: '#FEE2E2',
  critical5: '#FFF5F5'
};
exports.criticalColors = criticalColors;
var primaryColors = {
  primary: '#0065D3',
  primary100: '#0065D3',
  primary60: '#66A3E5',
  primary10: '#E6F0FB',
  primary5: '#F2F7FD'
};
exports.primaryColors = primaryColors;
var componoColors = {
  compono: '#EE563D',
  compono100: '#EE563D',
  compono60: '#F3805D',
  compono10: '#FFDBCF',
  compono5: '#FFEDE7'
};
exports.componoColors = componoColors;
var blackColors = {
  black100: '#2b2b2b',
  black80: '#555555',
  black60: '#808080',
  black30: '#BFBFBF',
  black10: '#eaeaea',
  black5: '#f4f4f4'
};
exports.blackColors = blackColors;
var statusifyStatusColors = {
  statusOk: statusColors.ok,
  statusWarning: statusColors.warning,
  statusCritical: statusColors.critical,
  statusDisabled: statusColors.disabled,
  statusUnknown: statusColors.unknown,
  statusInvalid: statusColors.invalid,
  statusInfo: statusColors.info
};

var colors = _objectSpread({
  brand: '#1A1944',
  black: '#2b2b2b',
  white: '#ffffff',
  focus: '#F2F7FD',
  'accent-1': '#F97316',
  'accent-2': '#C2410C',
  'accent-3': '#0065D3',
  'accent-4': '#484769',
  'neutral-1': '#FBFAFF',
  'neutral-2': '#C3410C',
  'neutral-3': '#1A1944',
  'neutral-4': '#76758F',
  'dark-1': '#555555',
  'dark-2': '#808080',
  'dark-3': '#aaaaaa',
  'dark-4': '#bfbfbf',
  'dark-5': '#d5d5d5',
  'light-1': '#fbfbfb',
  'light-2': '#f9f9f9',
  'light-3': '#f4f4f4',
  'light-4': '#eaeaea',
  'light-5': '#dfdfdf'
}, statusifyStatusColors, {}, successColors, {}, warningColors, {}, criticalColors, {}, primaryColors, {}, componoColors, {}, blackColors);

exports.colors = colors;
var font = {
  family: 'DM Sans, sans-serif',
  size: '16px',
  height: '1.5'
};
var spacing = {
  none: '0px',
  xsmall: '0.25rem',
  // 4px
  small: '0.5rem',
  // 8px
  medium: '1rem',
  // 16px
  large: '1.5rem',
  // 24px
  xlarge: '2rem',
  // 32px
  xxlarge: '4rem' // 64px

};
var uiKitTheme = {
  global: {
    font: font,
    colors: colors,
    spacing: spacing,
    breakpoints: {
      small: {
        value: 768
      },
      medium: {
        value: 1040
      }
    },
    input: {
      weight: 400,
      color: colors.black
    }
  },
  text: {
    small: {
      size: '14px',
      height: '20px'
    },
    medium: {
      size: '16px',
      height: '24px'
    }
  },
  fontWeight: {
    regular: '400',
    medium: '500',
    bold: '700'
  }
};
/* Keep grommit overrides separate from theme to prevent tainting the theme type */

exports.uiKitTheme = uiKitTheme;
var overrides = {
  /* Select background colour and remove border */
  select: {
    weight: 400,
    control: {
      extend: {
        width: '100%',
        borderWidth: 1,
        borderColor: colors['dark-1'],
        borderRadius: '4px',
        background: colors.white
      }
    },
    container: {
      extend: {
        maxHeight: '50vh'
      }
    },
    searchInput: (0, _styledComponents.default)(_TextInput.TextInput).withConfig({
      displayName: "searchInput",
      componentId: "sc-15jrole-0"
    })({
      // Safari on iOS will auto zoom onto selects that have font-size smaller than 16
      fontSize: 16
    })
  },
  layer: {
    /* Get the dialog and overlay to be above the nav bar */
    zIndex: '100'
  },
  global: {
    drop: {
      /* This is for select's in dialogs to get over the above zIndex */
      zIndex: '110'
    }
  }
};
var defaultTheme = (0, _utils.deepMerge)(_defaultProps.defaultProps.theme, uiKitTheme, overrides);
exports.defaultTheme = defaultTheme;